import {JackpotWidgetClockSiBox} from "./jackpot-widget-clock.si.box";

export const JackpotWidgetClockSiCisBox = JackpotWidgetClockSiBox;
